import { render } from "./infoQuestionMark.vue?vue&type=template&id=447178c2"
import script from "./infoQuestionMark.vue?vue&type=script&lang=js"
export * from "./infoQuestionMark.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__